'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { analytics } from '@/lib/analytics';

interface AnalyticsProps {
  fbPixelId?: string;
}

export function Analytics({ fbPixelId }: AnalyticsProps) {
  useEffect(() => {
    // Track initial page view for Facebook Pixel after script loads
    // Note: GA4 page views are now automatic via @next/third-parties GoogleAnalytics
    const handleLoad = () => {
      analytics.trackPageView();
    };

    // Delay to ensure scripts are loaded
    const timer = setTimeout(handleLoad, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Facebook Pixel */}
      {fbPixelId && (
        <Script id="facebook-pixel" strategy="afterInteractive">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            
            fbq('init', '${fbPixelId}');
            fbq('track', 'PageView');
          `}
        </Script>
      )}

      {/* Development mode indicator */}
      {fbPixelId?.includes('123456789') && (
        <Script id="analytics-debug" strategy="afterInteractive">
          {`
            console.log('[Analytics] Debug mode enabled');
            console.log('[Analytics] GA4 handled by @next/third-parties GoogleAnalytics');
            console.log('[Analytics] FB Pixel ID:', '${fbPixelId || 'not configured'}');
          `}
        </Script>
      )}
    </>
  );
}
